export default __webpack_public_path__ + "static/media/ivan.114feb22.jpg";